import useSearchContext from "@/lib/redux-search/use-search-context"
import { filterUpdaters } from "@/lib/redux-search/use-facet"
import React from "react"
import {
  useHits,
  usePagination__LEGACY,
  useFilter__LEGACY,
  useFacet__LEGACY,
} from "@/lib/redux-search"

export function useSearch() {
  const searchMethods = useSearchContext()

  return React.useMemo(() => {
    const { filters, clearAllFilters, search, pagination } = searchMethods
    return {
      clearFilters() {
        clearAllFilters()
        pagination.setPage(1)
        search()
      },
      removeFacetFilterValue(facetId: string, { name }: { name: string }) {
        filters.updateValues(facetId, filterUpdaters.remove(name))
        pagination.setPage(1)
        search()
      },
    }
  }, [searchMethods])
}

export function useResults() {
  return useHits()
}

export { usePagination__LEGACY as usePagination }

export { useFilter__LEGACY as useFilter }
export { useFacet__LEGACY as useFacet }
